import { Routes } from '@angular/router';
import { ProfileComponent } from './profile/profile.component';
import { SearchOverviewComponent } from './search-overview/search-overview.component';
import { OfferDetailsComponent } from './offer-details/offer-details.component';
import { AuthGuard } from './guard/AuthGuard';
import { CompanyViewComponent } from './company-view/company-view.component';
import { AddOfferComponent } from './company-view/add-offer/add-offer.component';
import { AdminViewComponent } from './admin-view/admin-view.component';
import { AddOffersComponent } from './company-view/add-offers/add-offers.component';
import { ImprintComponent } from './footer/imprint/imprint.component';
import { AdvisoryBoardViewComponent } from './advisory-board-view/advisory-board-view.component';
import { FeedbackComponent } from './advisory-board-view/feedback/feedback.component';
import { ChatComponent } from './chat/chat.component';
import { HomeComponent } from './home/home.component';
import { CompanyManagementComponent } from './company-management/company-management.component';
import { CompanyOnboardingComponent } from './company-onboarding/company-onboarding.component';
import { AuthLayoutComponentComponent } from '@/app/layouts/auth-layout-component/auth-layout-component.component';
import { UnauthLayoutComponentComponent } from '@/app/layouts/unauth-layout-component/unauth-layout-component.component';
import { UserOnboardingComponent } from './user-onboarding/user-onboarding.component';
import { UserRequiresOnboardingGuard } from './guard/UserRequiresOnboarding';
import { FeedbackHistoryComponent } from './feedback-history/feedback-history.component';
import { CompanyOnboardingGuard } from '@/app/guard/CompanyOnboardingGuard';
export const routes: Routes = [
  // Public routes without any guards
  {
    path: '',
    component: UnauthLayoutComponentComponent,
    // canActivate: [UserRequiresOnboardingGuard, CompanyOnboardingGuard],
    children: [
      { path: '', component: HomeComponent },
      { path: 'home', component: HomeComponent },
      { path: 'sondisa', component: ChatComponent },
      { path: 'details/:id', component: OfferDetailsComponent },
      { path: 'search', component: SearchOverviewComponent },
      { path: 'imprint', component: ImprintComponent },
    ],
  },
  {
    path: '',
    component: AuthLayoutComponentComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'user-onboarding',
        component: UserOnboardingComponent,
      },
      {
        path: 'company-onboarding',
        component: CompanyOnboardingComponent,
        canActivate: [AuthGuard],
        data: { roles: ['company'] },
      },
    ],
  },
  {
    path: '',
    component: AuthLayoutComponentComponent,
    canActivate: [
      AuthGuard,
      UserRequiresOnboardingGuard,
      CompanyOnboardingGuard,
    ],
    children: [
      {
        path: 'profile',
        component: ProfileComponent,
      },
      {
        path: 'company',
        component: CompanyViewComponent,
        canActivate: [AuthGuard],
        data: { roles: ['company', 'admin'] },
      },
      {
        path: 'company-management',
        component: CompanyManagementComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
      },
      {
        path: 'add-offer',
        component: AddOfferComponent,
        canActivate: [AuthGuard],
        data: { roles: ['company', 'admin'] },
      },
      {
        path: 'edit/:id',
        component: AddOfferComponent,
        canActivate: [AuthGuard],
        data: { roles: ['company', 'admin'] },
      },
      {
        path: 'feedback-history/:id',
        component: FeedbackHistoryComponent,
        canActivate: [AuthGuard],
        data: { roles: ['company', 'admin'] },
      },
      {
        path: 'admin',
        component: AdminViewComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
      },
      {
        path: 'add-offers',
        component: AddOffersComponent,
        canActivate: [AuthGuard],
        data: { roles: ['company'] },
      },
      {
        path: 'advisory-board',
        component: AdvisoryBoardViewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'feedback/:id',
        component: FeedbackComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
];
